import { useContext } from "react";
import { action } from "mobx";
import { observer } from "mobx-react-lite";

import { EditorWrapper } from "@pages/editor/components/EditorWrapper";
import { DEFAULT_MONACO_OPTIONS } from "@pages/editor/constants";
import { WorkbenchContext } from "@pages/editor/providers";

import { MonacoEditor } from "src/monaco";

const Editor = () => {
  const { workbench } = useContext(WorkbenchContext);
  const { bundle, editors } = workbench;

  if (bundle === null) return null;

  const { ruleText, setRuleText } = bundle;

  return (
    <EditorWrapper id="rule-editor">
      <MonacoEditor
        value={ruleText}
        onChange={action((value) => {
          if (value !== undefined) {
            setRuleText(value);
            editors.onRuleEditorChange(value);
          }
        })}
        onMount={editors.onRuleEditorMount}
        language="yaml"
        options={{ ...DEFAULT_MONACO_OPTIONS }}
      />
    </EditorWrapper>
  );
};

export const RuleEditor = observer(Editor);
